module.exports = __webpack_public_path__ + "static/holo-blue-1a4b745d89c684487c6a87437d347c0a.png";